import React, { Component, Fragment } from 'react';
import intl from 'react-intl-universal';
import Grid from '@material-ui/core/Grid';
import LoginForm from './forms/LoginFormPres';
import LoginError from './forms/LoginErrorPres';
import { LOGOUT_URL } from 'src/constants/constants.js';
import SelectRoleContainer from '../containers/SelectRoleContainer';

export const validateMail = email => {
  var re = /^(([^<>()[\]\\.,;:\s@|]+(\.[^<>()[\]\\.,;:\s@|]+)*)|(|.+|))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

class Login extends Component {
  state = {
    loginemail: '',
    loginpassword: '',
    blankPassword: false,
    blankEmail: false,
    error: false,
  };

  componentDidMount() {
    const { logoutSession } = this.props;

    if (window.location.href.includes(LOGOUT_URL)) {
      sessionStorage.clear();
      logoutSession();
    }
  }

  onLoginClick = evt => {
    evt.preventDefault();
    const { loginemail, loginpassword } = this.state;
    const emailIsValid = validateMail(loginemail);
    this.setState({
      blankEmail: !emailIsValid,
      blankPassword: loginpassword === '',
      error: !emailIsValid || loginpassword === '',
    });
    if (emailIsValid && loginpassword !== '') {
      return this.props.onClick(loginemail, loginpassword);
    }
  };

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };

  render() {
    const { error, loginStatus, isRoleSelect } = this.props;
    return isRoleSelect ? (
      <SelectRoleContainer />
    ) : (
      <Fragment>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <div className="title">{intl.get('login.title')}</div>
        </Grid>
        {error && error.message ? <LoginError isUserLocked={false} numberAttempts={0} error={error} maxAttempts={'third attempt'} /> : null}
        <LoginForm
          hasError={this.state.error || (error && error.message !== '')}
          onChange={this.handleChange}
          isUserLocked={false}
          actionButton={this.onLoginClick.bind(this)}
          loginStatus={loginStatus}
          blankEmail={this.state.blankEmail}
          blankPassword={this.state.blankPassword}
        />
      </Fragment>
    );
  }
}

export default Login;
